export default __webpack_public_path__ + "static/media/settings.2a80d2ed.svg";